import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { APP_URL_PAYMENT, STORAGE_KEY_USER_VISITED_PAYMENTS } from '../const';
import storageService from '../service/StorageService';
import { tryToCreateOfferRedirect } from '../store/slices/modalsSlice';

const useCatchRedirect = () => {
    const location = useLocation();
    const dispatch = useDispatch();

    useEffect(() => {
        const pathname = location.pathname;
        if (pathname === '/' + APP_URL_PAYMENT) {
            storageService.add(STORAGE_KEY_USER_VISITED_PAYMENTS, true);
            return;
        }

        const isUserVisitedPayments = storageService.get(STORAGE_KEY_USER_VISITED_PAYMENTS);
        if (isUserVisitedPayments) {
            storageService.delete(STORAGE_KEY_USER_VISITED_PAYMENTS);
            dispatch(tryToCreateOfferRedirect());
        }
    }, [location.pathname]);
};

export default useCatchRedirect;
